import type { CSSProperties } from 'react'
import type { LinkRect } from './types'
import { calculatePreviewPosition } from './calculatePreviewPosition'

export function getMapPreviewPositionStyle(
  linkRect: LinkRect,
  estimatedHeight: number,
  drawerElement?: HTMLElement | null,
): CSSProperties {
  const position = calculatePreviewPosition(linkRect, estimatedHeight)
  const bounds = drawerElement?.getBoundingClientRect()
  return {
    // oxlint-disable-next-line logical-css/no-physical-properties
    left: position.left - (bounds?.left ?? 0),
    ...(position.top !== undefined && { top: position.top - (bounds?.top ?? 0) }),
    ...(position.bottom !== undefined && { bottom: bounds ? bounds.bottom - window.innerHeight + position.bottom : position.bottom }),
  }
}
